/**
 * Polish language translations.
 * Format: {'property': 'translation value';}
 */
export const LANG_PL_TRANS = {
    // menu
    'lvt.menu.twroute': 'Routes',
    'lvt.menu.twcalloff': 'twCalloff',
    'lvt.menu.twslot': 'twSlot',
    'lvt.menu.slot_booking': 'Smart Booking',
    'lvt.menu.twdoc': 'twDoc',
    'lvt.menu.twcost': 'twCost',
    'lvt.menu.lvt': 'Live Tracking',
    'lvt.menu.app_name': 'Transwide',
    'lvt.menu.my_profile': 'Mój profil',
    'lvt.menu.tw_profile': 'Profil TW',
    'lvt.menu.company_profile': 'Profil firmy',
    'lvt.menu.my_notifications': 'Moje powiadomienia',
    'lvt.menu.sign_out': 'Wyloguj się',

    // footer
    'lvt.footer.back_to_top': 'Wróć do początku strony',
    'lvt.footer.terms_of_use': 'Warunki użytkowania',
    'lvt.footer.privacy_policy': 'Polityka prywatności',
    'lvt.footer.support_information': 'Informacje dot. wsparcia',
    'lvt.footer.transwide_home': 'Strona startowa Transwide',
    'lvt.footer.license_nr': 'Numer licencji:',
    'lvt.footer.build_version': 'Wersja w budowie:',

    // order list columns
    'lvt.order_list.header': 'Lista zamówień',
    'lvt.order_list.column.shipperCompany': 'Firma Załadowcy',
    'lvt.order_list.column.reference': 'Nr referencyjny',
    'lvt.order_list.column.status': 'Status',
    'lvt.order_list.column.statusReason': 'Przyczyna statusu',
    'lvt.order_list.column.senderCompany': 'Firma Nadawcy',
    'lvt.order_list.column.senderZipcode': 'Kod pocztowy Nadawcy',
    'lvt.order_list.column.senderCity': 'Miasto Nadawcy',
    'lvt.order_list.column.receiverCompany': 'Firma Odbiorcy',
    'lvt.order_list.column.receiverZipcode': 'Kod pocztowy Odbiorcy',
    'lvt.order_list.column.receiverCity': 'Miasto Odbiorcy',
    'lvt.order_list.column.carrierName': 'Nazwa przewoźnika',
    'lvt.order_list.column.plannedPickupEndDate': 'Planowany odbiór',
    'lvt.order_list.column.etaPickup': 'Oczekiwany czas przyjazdu przy odbiorze',
    'lvt.order_list.column.delayAtPickup': 'Opóźnienie odbioru',
    'lvt.order_list.column.plannedDeliveryEndDate': 'Planowana dostawa',
    'lvt.order_list.column.etaDelivery': 'Oczekiwany czas przyjazdu przy dostawie',
    'lvt.order_list.column.delayAtDelivery': 'Opóźnienie dostawy',
    'lvt.order_list.column.timestamps': 'Znaczniki czasu',
    'lvt.order_list.column.bookingPickupTime': 'Booking pickup',
    'lvt.order_list.column.bookingDeliveryTime': 'Booking delivery',

    // status order list
    'lvt.order_list.status.requested': 'Wymagane',
    'lvt.order_list.status.failed': 'Błąd',
    'lvt.order_list.status.waiting': 'Oczekujące',
    'lvt.order_list.status.active': 'Aktywne',
    'lvt.order_list.status.stopped': 'Błąd',
    'lvt.order_list.status.completed': 'Ukończone',
    'lvt.order_list.status.cancelled': 'Anulowane',
    'lvt.order_list.status.timeout': 'Wstrzymane',

    // status reason order list
    'lvt.order_list.status_reason.carrier_not_assigned': 'Wybór Przewoźnika w toku',
    'lvt.order_list.status_reason.plate_number_not_present': 'Nie podano nr rejestracyjnego',
    'lvt.order_list.status_reason.plate_number_not_recognized': 'Nie rozpoznano nr rejestracyjnego',
    'lvt.order_list.status_reason.plate_number_not_operational': 'Błędny nr rejestracyjny',
    'lvt.order_list.status_reason.technical_error_not_posted': 'Technical error when creating the tour in GH',

    // pagination
    'lvt.order_list.pagination.rows_per_page': 'wierszy na stronie',
    'lvt.order_list.pagination.first': 'Pierwsza',
    'lvt.order_list.pagination.previous': 'Poprzednia',
    'lvt.order_list.pagination.next': 'Następna',
    'lvt.order_list.pagination.last': 'Ostatnia',
    'lvt.order_list.pagination.no_orders_found': 'Nie znaleziono zamówień',

    // tracked device
    'lvt.map.tracked_device.trailer': 'Przyczepa',
    'lvt.map.tracked_device.tractor': 'Ciągnik siodłowy',
    'lvt.map.tracked_device.mobile': 'Tel. kom.',

    // map
    'lvt.map.button.open_settings': 'Open settings',
    'lvt.map.button.open_order_list': 'Otwórz listę zamówień',
    'lvt.map.traffic_information.traffic': 'Traffic',
    'lvt.map.traffic_information.fast': 'Fast',
    'lvt.map.traffic_information.slow': 'Slow',
    'lvt.map.pickup_popup.pickup': 'Odbiór',
    'lvt.map.pickup_popup.date': 'Data',
    'lvt.map.pickup_popup.address': 'Adres',
    'lvt.map.delivery_popup.delivery': 'Dostawa',
    'lvt.map.delivery_popup.date': 'Data',
    'lvt.map.delivery_popup.address': 'Adres',
    'lvt.map.current_gps_popup.in_transit_to_at_delivery': 'W drodze do miejsca dostawy',
    'lvt.map.current_gps_popup.in_transit_to_at_pickup': 'W drodze do miejsca odbioru',
    'lvt.map.current_gps_popup.current_speed': 'Bieżąca prędkość',
    'lvt.map.current_gps_popup.average_speed': 'Średnia prędkość',
    'lvt.map.current_gps_popup.last_location_update': 'Aktualizacja ostatniej lokalizacji',
    'lvt.map.current_gps_popup.eta': 'Oczekiwany czas przyjazdu',
    'lvt.map.current_gps_popup.planned_time': 'Planowany czas',
    'lvt.map.current_gps_popup.arrival_delay': 'Opóźnienie przyjazdu',
    'lvt.map.current_gps_popup.speed_unit': 'km/h',

    // timestamps
    'lvt.order_list.timestamp.arrived_at_origin': 'Osiagnięto punkt odbioru',
    'lvt.order_list.timestamp.not_arrived_at_origin': 'Nie osiągnieto punktu odbioru',
    'lvt.order_list.timestamp.left_origin': 'Opuszczono punkt odbioru',
    'lvt.order_list.timestamp.not_left_origin': 'Nie opuszczono punktu odbioru',
    'lvt.order_list.timestamp.arrived_at_destination': 'Osiagnięto miejsce przeznaczenia',
    'lvt.order_list.timestamp.not_arrived_at_destination': 'Nie osiagnieto miejsca przeznaczenia',
    'lvt.order_list.timestamp.left_destination': 'Opuszczono miejsce przeznaczenia',
    'lvt.order_list.timestamp.not_left_destination': 'Nie opuszczono miejsca przeznaczenia',

    // settings
    'lvt.settings.header': 'Settings',
    'lvt.settings.delay_management': 'Delay management',
    'lvt.settings.add_new': 'Add new +',
    'lvt.settings.column.ruleTitle': 'Rule title',
    'lvt.settings.column.type': 'Type',
    'lvt.settings.column.offset': 'Offset',
    'lvt.settings.column.actions': 'Actions',
    'lvt.settings.create_rule': 'Create rule',
    'lvt.settings.view_rule': 'View rule',
    'lvt.settings.go_back_to_list': 'Go back to list',
    'lvt.settings.edit_rule': 'Modify rule',
    'lvt.settings.delete_rule': 'Delete rule',
    'lvt.settings.delete_this_rule': 'Delete this rule',
    'lvt.settings.rule_type.delay': 'Delay',
    'lvt.settings.rule_type.at_risk': 'At risk',
    'lvt.settings.no_rules_found': 'No rules found',
    'lvt.settings.delete_popup.message': 'Are you sure you want to delete this rule?',
    'lvt.settings.field.rule_title': 'Rule title',
    'lvt.settings.field.location_type': 'Location type',
    'lvt.settings.field.location_type_pickup': 'Pickup',
    'lvt.settings.field.location_type_delivery': 'Delivery',
    'lvt.settings.field.rule_type': 'Rule type',
    'lvt.settings.field.rule_type_delay.time_offset': 'Time offset threshold',
    'lvt.settings.field.rule_type_delay.unit_minutes': 'Minutes',
    'lvt.settings.field.rule_type_delay.unit_hours': 'Hours',
    'lvt.settings.field.rule_type_delay.before': 'Before',
    'lvt.settings.field.rule_type_delay.after': 'After',
    'lvt.settings.field.rule_type_atrisk.percentage': 'Percentage threshold',
    'lvt.settings.field.schedule_date_priority': 'Schedule date priority',
    'lvt.settings.field.schedule_date_priority.booking_time': 'Booked timeslot',
    'lvt.settings.field.schedule_date_priority.planned_earliest_arrival': 'Earliest planned arrival',
    'lvt.settings.field.schedule_date_priority.planned_latest_arrival': 'Latest planned arrival',
    'lvt.settings.field.error.required': 'is required',

    // popup
    'lvt.popup.yes': 'Yes',
    'lvt.popup.cancel': 'Cancel',

    // messages from backend
    'lvt.message.info_saved_successfully': 'Info saved successfully.',
    'lvt.message.info_updated_successfully': 'Info updated successfully.',
    'lvt.message.info_deleted_successfully': 'Info deleted successfully.',
    'lvt.message.warn': 'Warning: ',
    'lvt.message.error': 'Error: ',
    'lvt.message.error_no_name_specified': 'No name specified.',
    'lvt.message.error_no_company_id_specified': 'No company Id specified.',
    'lvt.message.error_no_location_type_specified': 'No location type specified.',
    'lvt.message.error_no_rule_type_specified': 'No rule type specified.',
    'lvt.message.error_date_priorities_not_specified': 'Date priorities not specified.',
    'lvt.message.error_delay_offset_not_specified': 'Delay offset not specified.',
    'lvt.message.error_at_risk_offset_not_specified': 'At risk offset not specified.',
    'lvt.message.error_no_entity_found': 'No entity found.',
    'lvt.message.error_could_not_convert_delay_rule': 'Could not convert delay rule.',

    // search
    'lvt.order_list.search': 'Search'
};



// WEBPACK FOOTER //
// ./src/app/services/translation/lang/lang-pl.ts